<app-contracts>admin-contracts works!</app-contracts>
